import { trackFormSubmit, windowExists } from '../../utils';

export const hideForm = form => (form.getFormElem().hide());

const matchesCurrentUrl = (followUpUrl) => {
  const currentHref = (windowExists && window.location.href.split('?')[0]) || null;
  const followUpHref = followUpUrl.split('?')[0];
  return currentHref === followUpHref;
};

const redirectTo = (followUpUrl) => {
  if (windowExists) {
    window.location.href = followUpUrl;
  }
};

const displayConfirmationText = () => {
  document.getElementById('confirmationText').style.visibility = 'visible';

  return false;
};

export const formLoadHandler = (form) => {
  form.onSuccess((values, followUpUrl) => {
    const formId = form.getId();
    hideForm(form);
    trackFormSubmit(formId);
    return matchesCurrentUrl(followUpUrl) ? displayConfirmationText() : redirectTo(followUpUrl);
  });
};

export const resetStyles = (form) => {
  const formEl = form.getFormElem()[0];
  const stylesBase = document.getElementById('mktoForms2BaseStyle');
  const stylesTheme = document.getElementById('mktoForms2ThemeStyle');

  if (stylesTheme) {
    const inlineMarketoStyle = stylesTheme.nextSibling;

    if (inlineMarketoStyle && inlineMarketoStyle.textContent && inlineMarketoStyle.textContent.indexOf(`mktoForm_`) >= 0) {
      inlineMarketoStyle.outerHTML = '';
    }

    const inFormStyles = formEl.getElementsByTagName('style');
    if (inFormStyles.length) {
      for (let i = 0; i < inFormStyles.length; i += 1) {
        inFormStyles[i].outerHTML = '';
      }
    }

    const styledEls = Array.from(formEl.querySelectorAll('[style]')).concat(formEl);
    styledEls.forEach(el => el.removeAttribute('style'));
    stylesTheme.outerHTML = '';
  }
  if (stylesBase) {
    stylesBase.outerHTML = '';
  }
};
